import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import { Projects } from 'data/projects';
const ClientCarousel = () => {
  // const Projects = [
  //   {
  //     id: 1,
  //     quote: `Working with HYPE on my website was an absolute pleasure. They did an outstanding job bringing my vision to life and were incredibly responsive to all my needs throughout the process. Their professionalism, attention to detail, and customer-first approach truly set them apart. I highly recommend HYPE to anyone looking for skilled and reliable brand and web designers`,
  //     author: "Maryanne Namutebi",
  //     position: "Chief Executive Officer",
  //     client: "Maryanne Kanyike Construction Consultants",
  //     industry: "Construction",
  //     website: "https://mkcc.netlify.app/",
  //     avatar: ""
  //   },
  //   {
  //     id: 2,
  //     quote: `Very imaginative and out of the box creative client. HYPE has worked on a number of Projects for me. Truly skilled and I would recommend them above the rest. Keep up the good work!`,
  //     author: "Maymuna Omar",
  //     position: "Director",
  //     client: "Patterns of Africa LTD",
  //     industry: "Fashion & Design",
  //     website: "",
  //     avatar: ""
  //   },
  //   {
  //     id: 3,
  //     quote: `Working with HYPE has been a game-changer for us. They crafted a social media strategy that perfectly aligns with our brand and has boosted both our online engagement and spa bookings. Their creativity and attention to detail make our content stand out. We’re thrilled with the results and excited to continue working with them`,
  //     author: "Warda Khamis",
  //     position: "Chief Executive Officer",
  //     client: "Lawar’d Spa",
  //     industry: "Wellness & Beauty",
  //     website: "",
  //     avatar: ""
  //   },
  //   {
  //     id: 4,
  //     quote: `For over three years, we struggled to promote our new tea and coffee products within a strict budget. Partnering with Hype was the solution we needed. Elvin and Edgar guided us from the start, and Magdalene’s design work was spot on. Their collaboration ensured we stayed on track and delivered exactly what we needed. I’ll definitely work with HYPE on future Projects and highly recommend their services.`,
  //     author: "Simon Gakinya",
  //     position: "Chief Executive Officer",
  //     client: "Mount Kenya Specialty Co. Ltd.",
  //     industry: "Food & Beverage",
  //     website: "",
  //     avatar: ""
  //   }
  // ];

  const getVisibleCount = () => {
    if (window.innerWidth < 640) return 1;
    if (window.innerWidth < 1024) return 2;
    return 4;
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleCount());
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
      setActiveIndex(0);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) =>
        prev === Projects.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(timer);
  }, [Projects.length]);

  const itemWidth = 100 / visibleCount;
  const scrollIndex = Math.max(
    0,
    Math.min(
      activeIndex - Math.floor(visibleCount / 2),
      Projects.length - visibleCount
    )
  );

  return (
    <section data-theme="dark" className="py-4 sm:py-16 lg:py-20 bg-gradient-to-br from-primary via-red-900 to-secondary">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-2">
            Trusted by <span className="text-gradient-gold">Industry Leaders</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white/80 max-w-3xl mx-auto">
            From Fortune 500 companies to innovative startups, we've partnered with
            brands that demand excellence in their visual storytelling.
          </p>
        </div>

        {/* Logos Carousel */}
        <div className="mb-6 py-2 overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${scrollIndex * itemWidth}%)` }}
          >
            {Projects.map((testimonial, index) => (
              <div
                key={testimonial.id}
                style={{ width: `${itemWidth}%` }}
                className="flex-shrink-0 px-2 sm:px-4"
              >
                <button
                  onClick={() => setActiveIndex(index)}
                  className={`w-full rounded-xl p-1 backdrop-blur-sm cinematic-transition
                    ${index === activeIndex
                      ? 'bg-white/30 ring-2 ring-accent'
                      : 'bg-white/10 hover:bg-white/20'
                    }`}
                >
                  <div className="text-center">
                    <div className="text-white font-bold text-sm ">
                      {testimonial.client}
                    </div>
                    <div className="text-accent font-semibold text-xs">
                      {testimonial.industry}
                    </div>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonial */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 md:p-12 text-center max-h-[420px] overflow-hidden flex flex-col justify-center">

          <blockquote className="text-base sm:text-xl md:text-2xl text-white/90 mb-8 leading-relaxed max-w-4xl mx-auto">
            "{Projects[activeIndex].quote}"
          </blockquote>

          <div className="flex items-center justify-center space-x-4">
            {Projects[activeIndex].avatar && (
              <Image
                src={Projects[activeIndex].avatar}
                alt={Projects[activeIndex].author}
                className="w-12 h-12 rounded-full object-cover"
              />
            )}
            <div>
              <div className="text-white font-semibold">
                {Projects[activeIndex].author}
              </div>
              <div className="text-accent text-sm font-semibold">
                {Projects[activeIndex].position}
              </div>
              <div className="text-white/60 text-sm">
                {Projects[activeIndex].client}
              </div>
              {Projects[activeIndex].website && (
                <a
                  href={Projects[activeIndex].website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-sm font-bold text-white hover:text-accent transition-colors"
                >
                  {Projects[activeIndex].website}
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Indicators */}
        <div className="flex justify-center space-x-2 mt-8">
          {Projects.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`w-3 h-3 rounded-full cinematic-transition
                ${index === activeIndex
                  ? 'bg-accent'
                  : 'bg-white/30 hover:bg-white/50'
                }`}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default ClientCarousel;
